import { callGetApi, callPostApi, callPutApi } from "api/ApiCaller";
import {
  Edit_Resturent_List_Item_PUT,
  Get_Resturent_List_Item_GET,
  Save_Resturent_List_Item_POST,
} from "api/ApiConst";
import { API_SUCCESS } from "api/ResponseCodes";
import MapAddressPicker from "components/common/MapAddressPicker";
import ModalWrapper from "components/common/ModalWrapper";
import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { MODAL_LOADER } from "utils/constants";
import { isEmpty } from "utils/TextUtils";

const RestaurantAddEdit = ({ show, hideModal, recordID, handleRefresh }) => {
  const [showLocModal, setShowLocModal] = useState(false);
  const [restaurantTitle, setRestaurantTitle] = useState(null);
  const [addressLoc, setAddressLoc] = useState({
    addressLine: "",
    latitude: "",
    longitude: "",
    country: "India",
    state: "",
    city: "",
    pinCode: "",
  });
  const record = { title: restaurantTitle, address: addressLoc };

  const currentLocation = {
    addressLat: addressLoc?.latitude,
    addressLng: addressLoc?.longitude,
    addressCountry: addressLoc?.country,
    addressState: addressLoc?.state,
    addressCity: addressLoc?.city,
    addressPostalCode: addressLoc?.pinCode,
  };

  const locationCallBack = (res) => {
    setAddressLoc({
      addressLine: res.addressText,
      latitude: res.addressLat,
      longitude: res.addressLng,
      country: res.addressCountry,
      state: res.addressState,
      city: res.addressCity,
      pinCode: res.addressPostalCode,
    });
    handleHideLocModal();
  };

  const handleHideLocModal = () => {
    setShowLocModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddressLoc({ ...addressLoc, [name]: value });
  };

  const checkInputValidation = () => {
    if (isEmpty(restaurantTitle)) {
      toast.error("Restaurant Name must not be empty.", {
        id: "restaurantTitle",
      });
      return;
    } else if (isEmpty(addressLoc.addressLine)) {
      toast.error("Address must not be empty.", {
        id: "addressLine",
      });
      return;
    } else if (isEmpty(addressLoc.latitude)) {
      toast.error("Latitude must not be empty.", {
        id: "latitude",
      });
      return;
    } else if (isEmpty(addressLoc.longitude)) {
      toast.error("Longitude must not be empty.", {
        id: "longitude",
      });
      return;
    } else if (isEmpty(addressLoc.city)) {
      toast.error("City Name must not be empty.", {
        id: "city",
      });
      return;
    } else if (isEmpty(addressLoc.state)) {
      toast.error("State Name must not be empty.", {
        id: "state",
      });
      return;
    } else if (isEmpty(addressLoc.country)) {
      toast.error("Country Name must not be empty.", {
        id: "country",
      });
      return;
    } else if (isEmpty(addressLoc.pinCode)) {
      toast.error("Pin Code must not be empty.", {
        id: "pinCode",
      });
      return;
    }

    //   const addressCheck = record.address;
    //   for (let x in addressCheck) {
    //     if (isEmpty(addressCheck[x])) {
    //       toast.error(`${x} Name must not be mepty.`);
    //       return false;
    //     }
    //   }
    // }

    return true;
  };

  const handleSubmit = () => {
    try {
      if (!checkInputValidation()) {
        return;
      }
      recordID
        ? //update
          callPutApi(
            MODAL_LOADER,
            Edit_Resturent_List_Item_PUT.replace("{uuid}", recordID),
            record,
            {},
            (res) => {
              if (res.errorCode === API_SUCCESS) {
                hideModal(false);
                handleRefresh();
              }
            }
          )
        : // Create
          callPostApi(
            MODAL_LOADER,
            Save_Resturent_List_Item_POST,
            record,
            {},
            (res) => {
              if (res.errorCode === API_SUCCESS) {
                hideModal(false);
                handleRefresh();
              }
            },
            (error) => {
              console.log(error);
            }
          );
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    recordID &&
      callGetApi(
        MODAL_LOADER,
        Get_Resturent_List_Item_GET.replace("{uuid}", recordID),
        {},
        (res) => {
          if (res.errorCode === API_SUCCESS) {
            setRestaurantTitle(res.responsePacket.title);
            setAddressLoc(res.responsePacket.address);
          }
        }
      );
  }, [recordID]);

  return (
    <>
      <ModalWrapper
        show={show}
        hide={hideModal}
        header={`${recordID ? "Update" : "Add"}`}
        handleSubmit={handleSubmit}
      >
        <div className="container">
          <div className="row">
            <div className="mb-3">
              <label htmlFor="" className="form-label">
                Restaurant Name
              </label>
              <input
                type="text"
                className="form-control"
                value={restaurantTitle}
                name="title"
                onChange={(e) => setRestaurantTitle(e.target.value)}
              ></input>
            </div>
            <div className="mb-3">
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <InputGroup>
                  <Form.Control
                    placeholder="Address"
                    aria-label="Address"
                    aria-describedby="basic-addon2"
                    value={addressLoc?.addressLine}
                    name="addressLine"
                    onChange={(e) => handleInputChange(e)}
                  />
                  <Button
                    variant="outline-secondary"
                    id="button-addon2"
                    onClick={() => setShowLocModal(true)}
                  >
                    location logo
                  </Button>
                </InputGroup>
              </Form.Group>
            </div>
            <div className="col-lg-4 mb-3">
              <label htmlFor="" className="form-label">
                Latitute
              </label>
              <input
                type="text"
                className="form-control"
                value={addressLoc?.latitude}
                name="latitude"
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="col-lg-4 mb-3">
              <label htmlFor="" className="form-label">
                Longitude
              </label>
              <input
                type="text"
                className="form-control"
                value={addressLoc?.longitude}
                name="longitude"
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="col-lg-4 mb-3">
              <label htmlFor="" className="form-label">
                City
              </label>
              <input
                type="text"
                className="form-control"
                value={addressLoc?.city}
                name="city"
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="col-lg-4 mb-3">
              <label htmlFor="" className="form-label">
                State
              </label>
              <input
                type="text"
                className="form-control"
                value={addressLoc?.state}
                name="state"
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="col-lg-4 mb-3">
              <label htmlFor="" className="form-label">
                Country
              </label>
              <input
                type="text"
                className="form-control"
                value={addressLoc?.country}
                name="country"
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="col-lg-4 mb-3">
              <label htmlFor="" className="form-label">
                Pin Code
              </label>
              <input
                type="text"
                className="form-control"
                value={addressLoc?.pinCode}
                name="pinCode"
                onChange={(e) => handleInputChange(e)}
              />
            </div>
          </div>
        </div>
      </ModalWrapper>

      {/*Set Location*/}
      <Modal
        show={showLocModal}
        onHide={handleHideLocModal}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MapAddressPicker
            currentLocation={currentLocation}
            locationCallBack={locationCallBack}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RestaurantAddEdit;
